/**
 *
 * @author arman
 * @since 9/27/17
 *
 */
import React from 'react';
import CommentDialog from './comment-dialog';
import ReviewDialog from './review-dialog.component';
import DocumentPreview from '../shared/file-upload/preview';
import PrescriptionDialog from './prescription-dialog.component';

/**
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const HiddenDialogs = (props) => {
  let {
    mission, prescriptionDialogOpen, togglePrescriptionDialog, className, prescription, comment, endMissionDialogOpen,
    reopenMissionDialogOpen, onChange, endMission, reopenMission, toggleEndMissionDialog, toggleReopenMissionDialog,
    review, reviewDialogOpen, toggleReviewDialog, submitReview, toggleReportPreviewDialog, reportPreviewDialogOpen,
    reportFile, fileType
  } = props;

  return (
    <div className={className}>
      {/*<ETADialog*/}
        {/*nextETA={nextETA}*/}
        {/*mission={mission}*/}
        {/*onSelect={onSelect}*/}
        {/*open={etaDialogOpen}*/}
        {/*submitETA={submitETA}*/}
        {/*toggleETADialog={toggleETADialog} />*/}
      {/*<CancelDialog*/}
        {/*onChange={onChange}*/}
        {/*onSelect={onSelect}*/}
        {/*canceledBy={canceledBy}*/}
        {/*cancelReason={cancelReason}*/}
        {/*cancelMission={cancelMission}*/}
        {/*open={cancelDialogOpen}*/}
        {/*toggleCancelDialog={toggleCancelDialog} />*/}
      <PrescriptionDialog
        mission={mission}
        open={prescriptionDialogOpen}
        prescription={prescription}
        togglePrescriptionDialog={togglePrescriptionDialog} />

      <CommentDialog
        open={endMissionDialogOpen}
        onChange={onChange}
        comment={comment}
        title="End Mission"
        onSubmit={endMission}
        toggleDialog={toggleEndMissionDialog}
      />

      <CommentDialog
        open={reopenMissionDialogOpen}
        onChange={onChange}
        comment={comment}
        title="Re-Open Mission"
        onSubmit={reopenMission}
        toggleDialog={toggleReopenMissionDialog}
      />
      <ReviewDialog
        review={review}
        onChange={onChange}
        open={reviewDialogOpen}
        submitReview={submitReview}
        toggleDialog={toggleReviewDialog}
      />
      <DocumentPreview
        file={reportFile}
        fileType={fileType}
        showPreview={reportPreviewDialogOpen}
        onRequestClose={toggleReportPreviewDialog}
      />
      {/*{*/}
        {/*mission.followup &&*/}
        {/*<FollowupReportDialog*/}
          {/*onCheck={onCheck}*/}
          {/*mission={mission}*/}
          {/*onSelect={onSelect}*/}
          {/*onChange={onChange}*/}
          {/*open={followupDialogOpen}*/}
          {/*followupDate={followupDate}*/}
          {/*followupTime={followupTime}*/}
          {/*doctorRating={doctorRating}*/}
          {/*isNextFollowup={isNextFollowup}*/}
          {/*followupReport={followupReport}*/}
          {/*toggleDialog={toggleFollowupDialog}*/}
          {/*submitFollowupReport={submitFollowupReport} />*/}
      {/*}*/}
    </div>
  );
};

export default HiddenDialogs;


// WEBPACK FOOTER //
// ./src/screens/mission-view/hidden-dialogs.component.js